export default (init, mode) => {
  const panelTitle = $(".footer-accordion__title");
  const visibilityMode = mode || "single";
  const isInitialized = init || "init";
  const transitionTime = 170;

  if (isInitialized === "init") {
    function hidePanels() {
      const activeTitles = panelTitle.filter(function() {
        return $(this).attr("aria-selected") === "true";
      });

      $.each(activeTitles, function() {
        $(this).attr("aria-selected", "false");
        $(this)
          .next()
          .slideUp(transitionTime);
      });
    }

    $.each(panelTitle, function() {
      const isOpen = $(this).attr("aria-selected");

      if (isOpen === "true") {
        $(this)
          .next()
          .slideDown(transitionTime);
      } else {
        $(this)
          .next()
          .slideUp(transitionTime);
      }
    });

    if (visibilityMode === "single") {
      panelTitle.on("click", function() {
        const title = $(this);
        const panel = $(this).next();

        if (panel.length) {
          if (panel.is(":visible")) {
            $.each(panelTitle, function() {
              hidePanels();
            });
          } else {
            hidePanels();
            title.attr("aria-selected", "true");
            panel.slideDown(transitionTime);
          }
        }
      });
    } else if (visibilityMode === "multiply") {
      panelTitle.on("click", function() {
        const panel = $(this).next();

        if (panel.length) {
          panel.slideDown(transitionTime);
        } else {
          panel.slideUp(transitionTime);
        }
      });
    }
  } else {
    $(panelTitle).unbind("click");
  }
};
